// extracted by mini-css-extract-plugin
export default {"subHeader":"styles__subHeader___pFjNc","titleBlock":"styles__titleBlock___oeoVo","title":"styles__title___RAP8x fonts__whitney-semibold___M7vMo"};